import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'customerImages',
  components: {
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  props: {
    entityType: {
      type: Number,
      required: true
    },
    entityId: {
      type: Number,
      required: true
    },
    showFileName: {
      type: Boolean,
      default: true
    },
    refName: {
      type: String,
      default: 'imagesDataGrid'
    }
  },
  data: function () {
    return {
      EnableEdit: false,
      Images: [],
      ImagesCols: [],
      imagesPageingOptions: { pageSize: 10, total: 0, page: 1 },
      imagesTotalRow: 0,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      var parameters = {
        entityType: this.entityType,
        entityId: this.entityId,
        loginEmail: this.getLoginName(),
        Options: this.imagesPageingOptions
      }

      axios.post('/Enquiries/FillImages', parameters)
        .then(response => {
          if (response.status == 200) {

            this.Images = response.data.imagesData.attachments;
            this.imagesTotalRow = response.data.itemsCount;

            this.ImagesCols = [];
            this.ImagesCols.push({ dataField: 'imageDate', caption: this.$t('enquiriesImages.imageDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYY });

            if (this.showFileName)
              this.ImagesCols.push({ dataField: 'fileName', caption: this.$t('enquiriesImages.fileName') });
          }
        })
        .catch(e => {  return false; })
    },
    imagesPageChange(pInfo) {
      this.imagesPageingOptions.page = pInfo.pageNumber;
      this.imagesPageingOptions.pageSize = pInfo.pageSize;
      this.getData();
    }
  },
}

